import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/division/importer/divisionImporterSelectors';
import DivisionService from 'src/modules/division/divisionService';
import fields from 'src/modules/division/importer/divisionImporterFields';
import { i18n } from 'src/i18n';

const divisionImporterActions = importerActions(
  'DIVISION_IMPORTER',
  selectors,
  DivisionService.import,
  fields,
  i18n('entities.division.importer.fileName'),
);

export default divisionImporterActions;